import React from 'react';

import AuTrap1 from '../../silks/AU/trap1.svg';
import AuTrap10 from '../../silks/AU/trap10.svg';
import AuTrap2 from '../../silks/AU/trap2.svg';
import AuTrap3 from '../../silks/AU/trap3.svg';
import AuTrap4 from '../../silks/AU/trap4.svg';
import AuTrap5 from '../../silks/AU/trap5.svg';
import AuTrap6 from '../../silks/AU/trap6.svg';
import AuTrap7 from '../../silks/AU/trap7.svg';
import AuTrap8 from '../../silks/AU/trap8.svg';
import AuTrap9 from '../../silks/AU/trap9.svg';
import GbTrap1 from '../../silks/GB/trap1.svg';
import GbTrap2 from '../../silks/GB/trap2.svg';
import GbTrap3 from '../../silks/GB/trap3.svg';
import GbTrap4 from '../../silks/GB/trap4.svg';
import GbTrap5 from '../../silks/GB/trap5.svg';
import GbTrap6 from '../../silks/GB/trap6.svg';
import UsTrap1 from '../../silks/US/trap1.svg';
import UsTrap2 from '../../silks/US/trap2.svg';
import UsTrap3 from '../../silks/US/trap3.svg';
import UsTrap4 from '../../silks/US/trap4.svg';
import UsTrap5 from '../../silks/US/trap5.svg';
import UsTrap6 from '../../silks/US/trap6.svg';
import UsTrap7 from '../../silks/US/trap7.svg';
import UsTrap8 from '../../silks/US/trap8.svg';

interface Props {
  raceCountryCode: string;
  trapNumber: number;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const jacketMap: Partial<Record<string, any>> = {
  GB: [GbTrap1, GbTrap2, GbTrap3, GbTrap4, GbTrap5, GbTrap6],
  AU: [AuTrap1, AuTrap2, AuTrap3, AuTrap4, AuTrap5, AuTrap6, AuTrap7, AuTrap8, AuTrap9, AuTrap10],
  US: [UsTrap1, UsTrap2, UsTrap3, UsTrap4, UsTrap5, UsTrap6, UsTrap7, UsTrap8]
};

const Jacket: React.FC<Props> = ({ raceCountryCode, trapNumber }) => {
  const SilkImage = jacketMap[raceCountryCode][trapNumber - 1];
  return SilkImage ? <SilkImage /> : null;
};

export default Jacket;
